/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import i18n from '../../i18n/AdHocBundle.properties';
import { IStateMetadataError } from '../store/types/StateTypes';

const format = (result: any, params: any) => {
    let res = result;
    if (params) {
        params.forEach((value: any, idx: any) => {
            res = res.replace('{'.concat(idx).concat('}'), value);
        });
    }
    return res;
}

// In some rare cases the server might send to us two error codes (like a main code and a secondary)
// in the same error response, so we need to convert these 2nd level codes into the messages just like
// we do it with the main error codes.
// In the next object we are trying to consolidate these rear cases and specify where in the error
// parameters we might expect the 2nd level error codes, which is presented as an array because there might be several.
// And I'd like to call these codes as 'extra'.
const errorCodesWithExtraCodes :any = {
    'calculated.field.expression.evaluation.error': [3]
}

const generateErrorMessage = (error: IStateMetadataError) => {
    let errorMessage: string = '';
    if (error) {
        const err = error.errorCode ? error : error.responseJSON;
        let parameters :any = [];

        if (err) {
            if (Array.isArray(err.parameters)) {
                // copy the parameters because we might change it
                parameters = [...err.parameters];
            }

            // The idea behind converting codes into messages is what these 2nd level codes translated into messages
            // then may be used by main error code
            const extraCodes = errorCodesWithExtraCodes[err.errorCode];
            if (Array.isArray(extraCodes)) {
                for (let i = 0; i < extraCodes.length; i += 1) {
                    /* eslint-disable no-continue */
                    const extraCodePosition = extraCodes[i];
                    if (typeof parameters[extraCodePosition] === 'undefined') {
                        // it seems like the server has changed it's parameters, and it's gonna be visible
                        // in the error message on UI
                        continue;
                    }
                    const extraCode = parameters[extraCodePosition];
                    let message = i18n[`adhoc.error.extra.${extraCode}`];
                    if (!message) {
                        // this means there is no translation for the error code, so let's leave the error code there
                        continue;
                    }
                    message = format(message, parameters);
                    parameters[extraCodePosition] = message;
                    /* eslint-enable no-continue */
                }
            }
        }

        errorMessage = err && err.errorCode && i18n[`adhoc.error.${err.errorCode}`] ? format(i18n[`adhoc.error.${err.errorCode}`], parameters)
            : i18n['adhoc.error.unexpected.error'];
    }
    return errorMessage;
}

export default generateErrorMessage;
